function inWeiXin() {
  var ua = navigator.userAgent.toLowerCase();
  if (ua.match(/MicroMessenger/i) == "micromessenger") return true;
  else return false;
}
if (inWeiXin()) {
  $('.body-content').on('touchstart', function (event) {
    var parentName = ['dl.quality-game', 'dl.recommend', 'div.subject', 'dl.billboard', 'dl.guess', '.bt-warp'];
    var isDown = false;
    parentName.forEach(function (v, i) {
      if ($(event.target).attr('type') == 'btn' && $(event.target).closest(parentName[i]).length > 0 && !$(event.target).hasClass('undown')) {
        isDown = true;
      }
    });
    if (isDown) {
      $('#popWechat').show();
      event.preventDefault ? event.preventDefault() : event.returnValue = false;
    }
  });
}
$('#popWechat').click(function () {
  $(this).hide();
});



// WEBPACK FOOTER //
// ./lib/js/public/weixin.js